import React from 'react';
import Pie from './Pie';
import { dateFormatter, futureDate, hasValue } from './functions/dateFunctions';
import { CrossButton } from './Icons';

const ProjectSidebar = (props) => {
  const { projectActive, projectDetails, colorPalette, handleProjectActive } = props

  return (
    <div className={ `project-sidebar ${ (projectActive === true) ? 'visible' : ''}`}>

      <div className='project-title-container project-padding'>
        <div className='project-container'>
          <span className='project-id'>
            <svg height="11" width="11">
              <circle cx="6" cy="6" r="5" stroke="white" strokeWidth="0" fill={colorPalette[projectDetails.tech]} />
            </svg>
            <h4 className='color-invert inline-style'>ID{projectDetails.id}</h4>
          </span>
          <div className='project-title-flex-container'>
            <h1>{projectDetails.name}</h1>
              <div onClick={() => handleProjectActive(false)}>
                <CrossButton className='cross-button cross-project'/>
              </div>
          </div>
          <h4 className='project-title-subheader'>Last Updated {dateFormatter(projectDetails.up)}</h4>
        </div>
      </div>



      <div className='project-pie-container project-padding'>
        <div className='project-container'>
          <div className='flex-container'>
            <Pie data={ projectDetails }/>


            { (
                ( hasValue(projectDetails.star)
                  || hasValue(projectDetails.fini)
                ) &&
                ( !hasValue(projectDetails.oper) ||
                  futureDate(projectDetails.oper)
                )

              ) &&

              <div className='flex-container-column pie-info'>

                { hasValue(projectDetails.star) &&
                  <div>
                    <h2 className='color-invert'>START DATE</h2>
                    <p className='color-invert'>{dateFormatter(projectDetails.star)}</p>
                  </div>
                }


                { hasValue(projectDetails.fini) &&
                  <div>
                    <h2 className='color-invert'>COMPLETION DATE</h2>
                    <p className='color-invert'>{dateFormatter(projectDetails.fini)}</p>
                  </div>
                }


          </div>

          }


          </div>

        </div>
      </div>




      <div className='project-info-container project-padding'>
        <div className='project-container'>



          { hasValue(projectDetails.stat) &&
            <div className='key'>
              <h2>CURRENT STATUS</h2>
              <p>
                {projectDetails.stat}
                {
                  (
                    !futureDate(projectDetails.oper)
                    && hasValue(projectDetails.oper)
                    && hasValue(projectDetails.aban)
                    && projectDetails.stat !== 'Abandoned'
                    && projectDetails.stat !== 'Decommissioned'
                  )
                  ? (<em> (since {dateFormatter(projectDetails.oper)})</em>)
                  : ""
                }
              </p>
            </div>
          }

          { hasValue(projectDetails.op) &&
            <div className='key'>
              <h2>OPERATOR</h2>
              <p>{projectDetails.op}</p>
            </div>
          }

          <div className='splitter'/>

            { hasValue(projectDetails.tech) &&
              <div className='key'>

                  <span className='project-id'>
                    <h2>ENERGY TYPE</h2>
                    <svg height="7" width="7">
                      <circle cx="4" cy="4" r="3" stroke="white" strokeWidth="0" fill={colorPalette[projectDetails.tech]} />
                    </svg>
                  </span>
                  <p>{projectDetails.tech}</p>

              </div>

            }

            { hasValue(projectDetails.capa) &&
              <div className='key'>
                <h2>INSTALLED CAPACITY</h2>
                <p>{projectDetails.capa}MW</p>
              </div>
            }

            { hasValue(projectDetails.stor) &&
              <div className='key'>
                <h2>STORAGE TYPE</h2>
                <p>{projectDetails.stor}</p>
              </div>
            }

            { hasValue(projectDetails.chp) &&
              <div className='key'>
                <h2>CHP ENABLED</h2>
                <p>{projectDetails.chp}</p>
              </div>
            }

            { hasValue(projectDetails.ro) &&
              <div className='key'>
                <h2>RO BANDING</h2>
                <p>{projectDetails.ro}MWh</p>
              </div>
            }

          <div className='splitter'></div>

          { hasValue(projectDetails.auth) &&
            <div className='key'>
              <h2>PLANNING AUTHORITY</h2>
              <p>{projectDetails.auth}</p>
            </div>
          }

          { hasValue(projectDetails.app) &&
            <div className='key'>
              <h2>PLANNING SUBMITTED</h2>
              <p>{dateFormatter(projectDetails.app)}</p>
            </div>
          }

          { hasValue(projectDetails.ref) &&
            <div className='key'>
              <h2>{!(projectDetails.link) ? 'PLANNING APPLICATION REFERENCE' : 'PLANNING LINK'}</h2>
              { !(projectDetails.link) && <p>{projectDetails.ref}</p> }
              { (projectDetails.link) &&  <a href={ projectDetails.link } target="_blank" rel="noreferrer"><p>{projectDetails.ref}</p></a> }
            </div>
          }
        </div>
      </div>

    </div>
  )
}

export default ProjectSidebar;
